import Spinner from '@/components/Custom/Spinner';
import Box from '@/components/Unistyles/Box';
import useDelayedLoading from '@/hooks/useDelayedLoading';

export default function LoadingPlaceholder({
  accessibilityLabel = 'Loading',
  testID,
  flex = true,
}: {
  accessibilityLabel?: string;
  testID?: string;
  flex?: boolean;
} = {}) {
  const visible = useDelayedLoading();
  return (
    <Box
      flex={flex}
      align="center"
      justify="center"
      accessible={visible}
      accessibilityRole="progressbar"
      accessibilityLabel={accessibilityLabel}
      accessibilityState={{ busy: true }}
      testID={testID}
    >
      <Spinner size="lg" containerStyle={{ opacity: visible ? 1 : 0 }} />
    </Box>
  );
}
